export const appConfig = {
    // max valid days for an affiliate code
    maxAffiliateCodeValidDays: 14,
    highConsumptionThreshold: 750,
    highConsumptionWattHours: 500, // the threshold for high consumption in watt-hours
    cloudinaryPath: 'https://res.cloudinary.com/dglbwcbch/image/upload/',
};